import React from 'react'
import { ReactComponent as DasboardIcon } from '@caudena/core/assets/dashboard_new.svg'
import { ReactComponent as TransactionsIcon } from '@caudena/core/assets/transactions_new.svg'
import { ReactComponent as IncidentsIcon } from '@caudena/core/assets/incidents_new.svg'
import { ReactComponent as CasesIcon } from '@caudena/core/assets/cases_new.svg'
import { ReactComponent as ClientsIcon } from '@caudena/core/assets/clients_new.svg'
import { NavMenuItem } from '@caudena/core/Layout/NavMenu'
import buildUrl from '@caudena/core/utils/buildUrl'
import { getConfig } from '@caudena/core/useConfig'
import GlobalSearch from './components/GlobalSearch'
import { Gear } from '@caudena/core/ui-kit'
import { ProfileItemContainer } from './components/ProfileItemContaner'

export const navItems: NavMenuItem[] = [
  {
    label: 'Dashboard',
    to: '/dashboard',
    icon: <DasboardIcon />,
    placement: 'top',
  },
  {
    label: 'Transfers',
    to: '/transfers',
    icon: <TransactionsIcon />,
    placement: 'top',
  },
  {
    label: 'Incidents',
    to: '/incidents',
    icon: <IncidentsIcon />,
    counterUrl: buildUrl`${getConfig()?.COMPLIANCE_API}/api/incidents/counter`,
    placement: 'top',
  },
  {
    label: 'Cases',
    to: '/cases',
    icon: <CasesIcon />,
    counterUrl: buildUrl`${getConfig()?.COMPLIANCE_API}/api/cases/counter`,
    placement: 'top',
  },
  {
    label: 'Clients',
    to: '/clients',
    icon: <ClientsIcon />,
    placement: 'top',
  },
  {
    label: 'Search',
    component: GlobalSearch,
    placement: 'middle',
  },
  {
    label: 'Settings',
    to: '/settings',
    icon: <Gear />,
    placement: 'middle',
  },
  {
    label: 'Profile',
    component: ProfileItemContainer,
    to: '/settings/profile',
    placement: 'bottom',
  },
]
